module.exports = __webpack_public_path__ + "img/undraw_art_museum_-8-or4.4e7a11b2.svg";